import moment from 'moment'

export function selected(date, currentDate){
  return moment(date).format("YYYY-MM-DD") == moment(currentDate).format("YYYY-MM-DD")
}